// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiHost: 'https://ews-group.app/api/pest-control',
  //apiHost: 'https://ews-group.dev/api/pest-control',
  apiHost: 'https://ews.netcomm.dev/api/pest-control',
  //apiHost: '/api/pest-control',

  //customerPortalLink: 'https://customer.ews-group.app/',
  //customerPortalLink: 'https://customer.ews-group.dev/',
  customerPortalLink: 'https://customer.ews.netcomm.dev/',
  version: '2026-02-04',
  appPrefix: 'PC_MOBILE',

  globalDateFormat: 'dd.MM.yyyy',
  globalDateFormatWithTime: 'dd.MM.yyyy, HH:mm',
};
